import { ReducerRegistry } from 'store';
import { SHOW_TOAST, HIDE_TOAST } from '../types';

const init_State = {
  show: false,
  type: '',
  title: '',
  body: '',
  actionValue: '',
  actionFunction: '',
};

export const state = ReducerRegistry.register(
  'toast',
  (state = init_State, action) => {
    switch (action.type) {
      case SHOW_TOAST:
        let actionVal = action.payload.actionValue || '';
        let actionFunc = action.payload.actionFunction || '';
        return {
          ...state,
          show: true,
          type: action.payload.type,
          title: action.payload.title,
          body: action.payload.body,
          actionValue: actionVal,
          actionFunction: actionFunc,
        };
      case HIDE_TOAST:
        return { ...state, show: false };
      default:
        return state;
    }
  }
);
